import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { Contactpersoon } from '../types/Contactpersoon'

export { deleteContactpersoonForEntity }

async function deleteContactpersoonForEntity({
  contactpersoon,
  entity,
}: {
  contactpersoon: Contactpersoon
  entity: Entity
}): Promise<Contactpersoon> {
  const { type, id } = entity
  const { _id } = contactpersoon

  const { data } = await apiClient({
    url: `/rest/${type}/${id}/contactpersoon/${_id}`,
    method: 'PATCH',
    data: { status: 'cancelled' },
  })

  return data
}
